export const buttonIconCss = {
  path: {
    strokeWidth: 3,
  },
};
